import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { MessageSquare, Clock } from "lucide-react";
import { Avatar, Username } from "./UserBadge";
import { formatDistanceToNow } from "date-fns";
import { ro } from "date-fns/locale";

export default function RecentActivityWidget() {
  const { data: posts, isLoading } = useQuery({
    queryKey: ["recentPosts"],
    queryFn: async () => {
      const res = await api.get("/posts/recent?limit=5");
      return res.data;
    },
    staleTime: 60000,
  });

  if (isLoading) {
    return <div className="animate-pulse space-y-4">
      {[...Array(4)].map((_, i) => (
        <div key={i} className="h-16 bg-white/5 rounded-xl" />
      ))}
    </div>;
  }

  if (!posts || posts.length === 0) {
    return <p className="text-zinc-500 font-mono text-sm p-4 text-center border border-white/5 rounded-xl bg-white/[0.02]">Nicio activitate recentă.</p>;
  }

  return (
    <div className="space-y-3">
      {posts.map((post) => (
        <div key={post._id} className="flex gap-4 p-4 rounded-xl border border-white/5 bg-white/[0.02] hover:bg-orange-500/5 hover:border-orange-500/20 transition-all group">
          <div className="shrink-0 mt-1">
            <Avatar user={post.author} size={42} hover />
          </div>
          <div className="flex-1 min-w-0">
            <Link to={`/topic/${post.topic_id}#post-${post._id}`} className="font-bold text-white text-sm group-hover:text-orange-400 transition-colors block truncate mb-1">
              {post.topic_title || "Re: Topic fără titlu"}
            </Link>
            <div className="flex items-center gap-2 text-[11px] font-mono text-zinc-500 uppercase tracking-wider">
              <Username user={post.author} />
              <span>•</span>
              <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {formatDistanceToNow(new Date(post.created_at), { addSuffix: true, locale: ro })}</span>
            </div>
          </div>
          <div className="shrink-0 flex items-center justify-center w-10 h-10 rounded-lg bg-white/[0.04] text-zinc-600 group-hover:bg-orange-500/10 group-hover:text-orange-400 transition-all self-center">
            <MessageSquare className="w-4 h-4" />
          </div>
        </div>
      ))}
      <div className="pt-2">
        <Link to="/forums" className="inline-flex items-center gap-1.5 text-xs font-black uppercase tracking-widest text-orange-400 hover:text-orange-300 transition-colors">
          Vezi tot forumul →
        </Link>
      </div>
    </div>
  );
}
